import { render, staticRenderFns } from "./editrole.vue?vue&type=template&id=21481999&scoped=true&"
import script from "./editrole.js?vue&type=script&lang=js&"
export * from "./editrole.js?vue&type=script&lang=js&"
import style0 from "./editrole.vue?vue&type=style&index=0&id=21481999&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21481999",
  null
  
)

export default component.exports